import { http } from './http' // eslint-disable-line

// recursively fill restOfTheData and return it as a Promise
export async function loadDataRecursively (next) {
    let restOfTheData = []
    return new Promise((resolve, reject) => {
        if (!next)
            return resolve(restOfTheData)
            http.st.get(next).then(async (res) => {
            restOfTheData = restOfTheData.concat(res.data.results, await loadDataRecursively(res.data.next))
            resolve(restOfTheData)
        })
    })
}

export function getAbsoluteElementHeight(el, countMarginAndBorder) {
    // Get the DOM Node if you pass in a string
    el = (typeof el === 'string') ? document.querySelector(el) : el 

    let res = el.offsetHeight
    if (countMarginAndBorder) {
        const styles = window.getComputedStyle(el)
        res += parseFloat(styles['marginTop']) +
               parseFloat(styles['marginBottom']) +
               parseFloat(styles['borderTopWidth']) +
               parseFloat(styles['borderBottomWidth'])
    }

    return Math.ceil(res)
}

export function getLSItemSafe (key, fallbackValue) {
  const value = localStorage.getItem(key)
  if (value == null || value === 'undefined')
      return fallbackValue
  if (value === 'true') return true
  if (value === 'false') return false
  try {
      return JSON.parse(value)
  } catch {
      return value
  }
}
